export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активация электронного чека"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Счет зачисления"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Серия"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код активации"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Проверить"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активировать"])}
}